import { ROLES, CUSTOMER_ROLES } from '@/constants/roles';

export default [
  {
    path: '',
    name: 'integrations',
    meta: {
      verticalMenu: {
        title: 'Integrations',
        icon: 'LinkIcon',
        isGroup: true
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ...CUSTOMER_ROLES]
    }
  },
  {
    path: '/integrations/my-integrations',
    name: 'integrations-my-integrations',
    component: () => import('@/views/pages/integrations/MyIntegrations.vue'),
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ...CUSTOMER_ROLES],
      verticalMenu: {
        title: 'My Integrations',
        icon: 'GridIcon',
        parent: 'integrations'
      }
    }
  },
  {
    path: '/integrations/my-orders',
    name: 'integrations-my-orders',
    component: () => import('@/views/pages/integrations/MyOrders.vue'),
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ...CUSTOMER_ROLES],
      verticalMenu: {
        title: 'My Orders',
        icon: 'ShoppingCartIcon',
        parent: 'integrations'
      }
    }
  }
];
